import { Box, Stack } from "@mui/material";
import { useProductContext } from "../ProductContext";
import { IngredientsData } from "./IngredientsData";
import { ScoreChart, ScoreChartValues } from "src/components/ScoreChart/ScoreChart";
import { IngredientsHeader } from "./IngredientsHeader";
import { SectionBox } from "@foodpilot/foods";

export const Ingredients = () => {
    const { product, selectedScore, allScoreWithVariations, isLoading, isRefetching, productDetailBuilder } =
        useProductContext();

    const unit = selectedScore.unit;
    const selectedScoreId = selectedScore.scoreId;

    const summary = productDetailBuilder.getSummary();
    if (summary === null) return null;

    const acc: ScoreChartValues & {
        total: number;
    } = { labels: [], values: [], total: 0 };
    const chartValues = summary.detail.ingredients?.reduce((prevAcc, ingredient) => {
        prevAcc.labels.push(ingredient.label);

        const score = ingredient.score ?? 0;
        prevAcc.values.push(score);
        prevAcc.total += score;
        return prevAcc;
    }, acc);

    return (
        <SectionBox header={<IngredientsHeader />} borderRadius={4} sx={{ backgroundColor: "white" }}>
            <Stack direction={"row"} gap={3.5} sx={{ backgroundColor: "white" }}>
                <Stack flex={5} gap={3}>
                    <IngredientsData product={product} scoreId={selectedScoreId} unit={unit} />
                </Stack>

                <Box flex={2}>
                    <ScoreChart
                        allScoreWithVariations={allScoreWithVariations}
                        selectedScore={selectedScore}
                        totalScore={chartValues?.total}
                        data={chartValues}
                        isLoading={isLoading}
                        isRefetching={isRefetching}
                        disableVariations={true}
                    />
                </Box>
            </Stack>
        </SectionBox>
    );
};
